import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, forwardRef, OnInit, ViewChild } from '@angular/core';

import { InputSharedComponent } from '../input/input.component';

import * as card_validator from 'card-validator';

export const CC_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(() => CreditCardSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-credit-card',
    templateUrl: './credit-card.component.html',
    providers: [
        CC_CUSTOM_INPUT_ACCESSOR
    ]
})

export class CreditCardSharedComponent extends InputSharedComponent implements OnInit {
    @ViewChild(InputSharedComponent) inputComponent: InputSharedComponent;

    cardIcon = 'custom-credit-card';

    set value(val) {
        this._value = val;
        this.pickCardIcon(val);
        this.onChange(val);
        this.onTouched();
    }

    formatValue(value: string): string {
        if (value) {
            // strip white spaces and non numbers
            // tslint:disable-next-line: radix
            const number = parseInt(value.replace(/ /g, ''));
            if (isNaN(number)) {
                return '';
            } else {
                // limit to 16 characters and add space every 4 characters
                return number.toString().substr(0, 16).match(/.{1,4}/g).join(' ');
            }
        }
    }

    pickCardIcon(number: string): void {
        const valid = card_validator.number(number);

        if (valid.card) {
            switch (valid.card.type) {
                case 'visa': this.icon = 'custom-cc-visa'; break;
                case 'mastercard': this.icon = 'custom-cc-mastercard'; break;
                case 'american-express': this.icon = 'custom-cc-amex'; break;
                default: this.icon = this.cardIcon;
            }
        } else {
            this.icon = this.cardIcon;
        }
    }

    updateValue(event: KeyboardEvent): void {
        const target = event.target as HTMLInputElement;

        const value = this.formatValue(target.value);
        if (value !== undefined) {
            target.value = value;
            this.value = value;
        }
    }

    ngOnInit(): void {
        if (this.icon) {
            this.cardIcon = this.icon;
        }

        this.inputComponent.updateValue = this.updateValue.bind(this);
    }
}
